import { OwnerPage, OwnerPageInfo, OwnerPageResponse } from "burde";
import * as api from "util/api";

export const getStmOwnerPages = async (
    culture: string,
    calendarSize: string,
) => {
    try {
        const { success, data } = await api.json.get(`api/ui/getOwnerPages`, {
            culture,
            calendarSize,
        });

        if (!success) {
            return;
        }

        return data as OwnerPageResponse;
    } catch (error) {
        return;
    }
};

export const getStmOwnerPageById = async (
    culture: string,
    calendarSize: string,
    id: number,
) => {
    const { success, data } = await api.json.get(`api/ui/getOwnerPageById`, {
        id,
        culture,
        calendarSize,
    });

    if (!success) return;

    return data as OwnerPage;
};

// Note: Not from Burde's API but from our own DB.
export const getOwnerPageById = async (id: string | number) => {
    try {
        const { success, data } = await api.json.get(`api/owner-pages/${id}`);

        if (!success) {
            return;
        }

        return data as OwnerPageInfo;
    } catch (error) {
        return;
    }
};

export const getDefaultOwnerPage = async (culture: string, format: string) => {
    const response = await getStmOwnerPages(culture, format);

    if (response === undefined) {
        return;
    }

    const ownerPage = await getStmOwnerPageById(
        culture,
        format,
        response.defaultLayout,
    );

    return ownerPage;
};
